<p-selectButton [options]="options" [name]="name" [(ngModel)]="value" [multiple]="isMultiSelect"
    [optionLabel]="optionLabel" [optionValue]="optionValue" [optionDisabled]="'disabled'"
    (onChange)="updateValue($event.value);"></p-selectButton>